/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getHospitals } from 'app/entities/hospital/hospital.reducer';
import { createEntity, getEntity, reset, updateEntity } from './shift.reducer';

export const ShiftUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const hospitals = useAppSelector(state => state.hospital.entities);
  const shiftEntity = useAppSelector(state => state.shift.entity);
  const loading = useAppSelector(state => state.shift.loading);
  const updating = useAppSelector(state => state.shift.updating);
  const updateSuccess = useAppSelector(state => state.shift.updateSuccess);

  const handleClose = () => {
    navigate(`/shift${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getHospitals({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.from !== undefined && typeof values.from !== 'number') {
      values.from = Number(values.from);
    }
    if (values.to !== undefined && typeof values.to !== 'number') {
      values.to = Number(values.to);
    }
    if (values.length !== undefined && typeof values.length !== 'number') {
      values.length = Number(values.length);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdate !== undefined && typeof values.lastUpdate !== 'number') {
      values.lastUpdate = Number(values.lastUpdate);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }

    const entity = {
      ...shiftEntity,
      ...values,
      hospital: hospitals.find(it => it.id.toString() === values.hospital?.toString()),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...shiftEntity,
          hospital: shiftEntity?.hospital?.id,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.shift.home.createOrEditLabel" data-cy="ShiftCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.shift.home.createOrEditLabel">Create or edit a Shift</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="shift-id"
                  label={translate('tinyMedicRestApp.shift.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField label={translate('tinyMedicRestApp.shift.name')} id="shift-name" name="name" data-cy="name" type="text" />
              <ValidatedField label={translate('tinyMedicRestApp.shift.code')} id="shift-code" name="code" data-cy="code" type="text" />
              <ValidatedField label={translate('tinyMedicRestApp.shift.from')} id="shift-from" name="from" data-cy="from" type="text" />
              <ValidatedField label={translate('tinyMedicRestApp.shift.to')} id="shift-to" name="to" data-cy="to" type="text" />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.length')}
                id="shift-length"
                name="length"
                data-cy="length"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.hasBonus')}
                id="shift-hasBonus"
                name="hasBonus"
                data-cy="hasBonus"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.active')}
                id="shift-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.cursor')}
                id="shift-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.lastUpdate')}
                id="shift-lastUpdate"
                name="lastUpdate"
                data-cy="lastUpdate"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.microSec')}
                id="shift-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
              />
              <ValidatedField
                label={translate('tinyMedicRestApp.shift.timestampEntry')}
                id="shift-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
              />
              <ValidatedField
                id="shift-hospital"
                name="hospital"
                data-cy="hospital"
                label={translate('tinyMedicRestApp.shift.hospital')}
                type="select"
              >
                <option value="" key="0" />
                {hospitals
                  ? hospitals.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/shift" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ShiftUpdate;
